import LowHierarchySelection from './LowHierarchySelection';
export const FUNCTION_TYPE = 9;
export const OPTION_TYPE = 10;
export const isSelectablePermissionType = (type) => type === FUNCTION_TYPE || type === OPTION_TYPE;
export default class PermissionLowHierarchySelection extends LowHierarchySelection {
    constructor() {
        super({ nodeIsSelectable: () => true });
    }
    toggleNodeSelected(oldTreeState, nodeId, context) {
        var _a;
        const model = oldTreeState.models[nodeId];
        if (!model || !isSelectablePermissionType(model.type))
            return oldTreeState;
        if (this.nodeIsSelected(oldTreeState, nodeId)) {
            return this.deselectPermission(oldTreeState, nodeId, context);
        }
        let treeState = oldTreeState;
        if (model.type === OPTION_TYPE) {
            const siblings = treeState.children[treeState.parents[nodeId]] || [];
            for (const siblingId of siblings) {
                if (siblingId !== nodeId &&
                    ((_a = treeState.models[siblingId]) === null || _a === void 0 ? void 0 : _a.type) === OPTION_TYPE &&
                    this.nodeIsSelected(treeState, siblingId)) {
                    treeState = this.deselectPermission(treeState, siblingId, context);
                }
            }
        }
        if (hasOptionDescendant(treeState, nodeId)) {
            return selectWithAncestors(treeState, nodeId);
        }
        return super.toggleNodeSelected(treeState, nodeId, context);
    }
    deselectPermission(oldTreeState, nodeId, context) {
        var _a;
        const newState = super.toggleNodeSelected(oldTreeState, nodeId, context);
        const { parents, children, models } = oldTreeState;
        const selectionStatuses = { ...newState.selectionStatuses };
        const removedIds = new Set();
        let parentId = parents[nodeId];
        while (parentId) {
            const parentType = (_a = models[parentId]) === null || _a === void 0 ? void 0 : _a.type;
            if (parentType === OPTION_TYPE ||
                (parentType === FUNCTION_TYPE &&
                    hasOptionDescendant(oldTreeState, parentId))) {
                break;
            }
            const siblings = children[parentId] || [];
            const anyChildSelected = siblings.some(childId => childId in selectionStatuses);
            if (!anyChildSelected) {
                delete selectionStatuses[parentId];
                removedIds.add(String(parentId));
                parentId = parents[parentId];
            }
            else {
                break;
            }
        }
        const selection = newState.selection.filter((node) => !removedIds.has(String(node.id)));
        return { ...newState, selectionStatuses, selection };
    }
}
function hasOptionDescendant({ children, models }, nodeId) {
    return (children[nodeId] || []).some(childId => {
        var _a;
        return ((_a = models[childId]) === null || _a === void 0 ? void 0 : _a.type) === OPTION_TYPE ||
            hasOptionDescendant({ children, models }, childId);
    });
}
function selectWithAncestors(treeState, nodeId) {
    const { models, parents } = treeState;
    const selectionStatuses = { ...treeState.selectionStatuses };
    selectionStatuses[nodeId] = true;
    let parentId = parents[nodeId];
    while (parentId) {
        selectionStatuses[parentId] = true;
        parentId = parents[parentId];
    }
    const selectedById = treeState.selection.reduce((hash, node) => {
        hash[String(node.id)] = node;
        return hash;
    }, {});
    return {
        ...treeState,
        selectionStatuses,
        selection: Object.keys(selectionStatuses)
            .map(id => models[id] || selectedById[id])
            .filter(node => !!node),
    };
}
